import React from 'react';
import PropTypes from 'prop-types';
import LoadingIcon from 'mdi-react/LoadingIcon';
import classNames from 'classnames';

const NoResults = ({
  loading, results, children, className, height,
}) => {
  const defaultMessage = (
    <React.Fragment>
      <div className="no-results__box__result">
        <span
          role="img"
          aria-label="Thinking image when no data available"
          className="no-results__box__result__data"
        >
        🤔
        </span>
        <span className="no-results__box__result__add-data" />
      </div>
      <div className="no-results__box__description">No data to display</div>
    </React.Fragment>
  );

  if (!loading && results.length > 0) {
    return null;
  }

  return (
    <React.Fragment>
      <div className={`${className} no-results`} style={{ height }}>
        {(loading) && <div className="loader"><LoadingIcon /></div>}
        <div className={classNames('no-results__box', { invisible: loading })} >
          {children || defaultMessage}
        </div>
      </div>
    </React.Fragment>
  );
};

NoResults.propTypes = {
  loading: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  results: PropTypes.array,
  children: PropTypes.node,
  className: PropTypes.string,
  height: PropTypes.string,
};

NoResults.defaultProps = {
  className: '',
  children: null,
  results: [],
  height: '',
};

export default NoResults;
